import React from 'react';
import styles from './styles.module.css';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Loader from '../../../components/Loader';

const PositionsTableSingle = () => {
  const { positions, loading } = useSelector((state) => state.positions);

  if (loading) return <div className={styles.loading}><Loader /></div>;

  const provider = positions.provider;
  const results = positions[provider]?.[`${provider}_results`] || [];

  if (!results.length) {
    return <div className={styles.loading}>Нет данных</div>;
  }

  const sorted = [...results].sort(
    (a, b) => new Date(a.created_at) - new Date(b.created_at)
  );

  const dates = sorted.map(item => moment(item.created_at).format('DD.MM.YY'));
  const positionsRow = sorted.map(item => Number(item.value).toFixed(2));
  const changesRow = sorted.map((item, index) => {
    const current = Number(item.value).toFixed(2);
    const prev = index > 0 ? Number(sorted[index - 1].value).toFixed(2) : current;
    const diff = (prev - current).toFixed(2);
    return diff;
  });

  return (
    <div className={styles.tableWrapper}>
      <h3 className={styles.tableTitle}>
        Ключевое слово: {positions.keyword?.keyword}
      </h3>
      <div className={styles.horizontalScroll}>
        <table className={styles.tableHorizontal}>
          <thead>
            <tr>
              <th>Тип</th>
              {dates.map(date => (
                <th key={date}>{date}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={styles.rowLabel}>Позиция</td>
              {positionsRow.map((pos, i) => (
                <td key={i}>{pos}</td>
              ))}
            </tr>
            <tr>
              <td className={styles.rowLabel}>Изменение</td>
              {changesRow.map((diff, i) => {
                let className = styles.equal;
                if (diff > 0) className = styles.negative;
                else if (diff < 0) className = styles.positive;
                return (
                  <td key={i} className={className}>
                    {diff > 0 ? `+${diff}` : diff < 0 ? diff : '–'}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PositionsTableSingle;
